import { FC, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Spin } from 'antd';
import V2Container from '@/common/components/Data/V2Container';
import { useMethods } from '@lhb/hook';
import DetailMain from './components/DetailMain';
import styles from './entry.module.less';
import { getShopDetail, getShopDetailByCode } from '@/common/api/expandStore/shop';
import DetailTitle from './components/DetailTitle';

/** 门店详情 */
const Detail: FC<{
  id,
  reload?,
  isMXBC?,
  readonly?: boolean,
  /** 入参是否为门店编码，为 true 时走按编码查询详情的接口 */
  isCode?: boolean,
  ref?,
}> = forwardRef(({ id, reload, isMXBC, readonly, isCode = false }, ref) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [detail, setDetail] = useState<any>({});
  const [innerMainHeight, setInnerMainHeight] = useState<number>(0);
  const editMainRef = useRef<any>();

  useImperativeHandle(ref, () => ({
    init: methods.init
  }));

  const methods = useMethods({
    /**
     * @description 初始化
     */
    init() {
      if (!id) return;
      methods.loadData(id);
    },
    async loadData(id: number | string) {
      setLoading(true);
      // isCode 为 true 表示传入的是门店编码，走按编码查询详情的接口
      const data = isCode ? await getShopDetailByCode({ number: id }) : await getShopDetail({ id });
      setLoading(false);
      setDetail(data);
    },
    /**
     * @description 重新加载
     * @param status 状态 true 需要加载详情， false 不需要加载详情
     * @return
     */
    reload(status = true) {
      if (status) methods.init();

      reload?.();
    },
    handleOperateSuccess() {
      editMainRef.current?.reloadAll();
    }
  });

  return (
    <Spin tip='数据正在加载中请稍等......' spinning={loading}>
      <V2Container
        emitMainHeight={(h) => setInnerMainHeight(h)}
        style={{ height: '100vh', width: '100%' }}
        className={styles.container}
        extraContent={{
          top: <DetailTitle detail={detail} reload={methods.handleOperateSuccess} readonly={readonly} />,
        }}>
        <DetailMain
          ref={editMainRef}
          detail={detail}
          reload={() => methods.reload(true)}
          isMXBC={isMXBC}
          style={{
            height: innerMainHeight || 'auto',
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '16px 40px'
          }}/>
      </V2Container>
    </Spin>
  );
});

export default Detail;
